import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Phone, ArrowRight } from "lucide-react";

const CtaBand = ({ title = "Un projet de raccordement ou de contrôle qualité ?" }) => (
  <section className="bg-midnight text-white" data-testid="cta-band">
    <div className="bg-blueprint-dark">
      <div className="mx-auto flex max-w-7xl flex-col items-start gap-8 px-4 py-20 sm:px-6 lg:flex-row lg:items-center lg:justify-between lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          <p className="font-display text-xs font-bold uppercase tracking-[0.25em] text-terrain">
            Parlons de votre projet
          </p>
          <h2 className="mt-3 max-w-2xl font-display text-3xl font-extrabold tracking-tight sm:text-4xl">
            {title}
          </h2>
          <p className="mt-3 max-w-xl text-white/60">
            Une équipe technique de terrain, disponible sur toute la France.
            Réponse rapide, devis clair.
          </p>
        </motion.div>
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.15 }}
          className="flex flex-col gap-3 sm:flex-row"
        >
          <Link
            to="/contact"
            data-testid="cta-devis-button"
            className="group flex items-center justify-center gap-2 bg-ciel px-6 py-3.5 font-display text-sm font-bold uppercase tracking-wider text-midnight transition-colors duration-200 hover:bg-white"
          >
            Parlez-nous de votre besoin
            <ArrowRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-1" />
          </Link>
          <a
            href="tel:+33605765066"
            data-testid="cta-call-button"
            className="flex items-center justify-center gap-2 border border-white/30 px-6 py-3.5 font-display text-sm font-bold uppercase tracking-wider text-white transition-colors duration-200 hover:border-white hover:bg-white hover:text-midnight"
          >
            <Phone className="h-4 w-4" />
            06 05 76 50 66
          </a>
        </motion.div>
      </div>
    </div>
  </section>
);

export default CtaBand;
